import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  static targets = ["comment"];

  showComment() {
    event.preventDefault();
    event.currentTarget.classList.add("d-none");
    this.commentTargets.forEach((target) => target.classList.remove("d-none"));
  }
}
